import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const WeatherTableHeader = ({ children }: Props) => {
  return (
    <th className="w-100 text-center leading-[25px] bg-[#eeeeee] border-r-[1px] border-r-[#adb5bd]">{children}</th>
  );
};
